(function () {
  if (window.__klATCBound) return;
  window.__klATCBound = true;
  var _learnq = (window._learnq = window._learnq || []);
  var lastATC = 0;

  function normalizeItemFromResponse(json) {
    if (!json) return null;
    if (json.item) return json.item;
    if (Array.isArray(json.items) && json.items.length) return json.items[0];
    if (json.id || json.variant_id) return json;
    return null;
  }

  function normalizeItemFromKV(obj) {
    var id =
      obj.id ||
      obj.variant_id ||
      obj.variantId ||
      obj["items[0][id]"] ||
      obj["items[0][variant_id]"];
    var qty = parseInt(
      obj.quantity || obj.qty || obj["items[0][quantity]"] || 1,
      10
    );
    if (!id) return null;
    return { id: Number(id) || id, quantity: isNaN(qty) ? 1 : qty };
  }

  function parseBodyToItem(body) {
    try {
      if (!body) return null;
      if (body instanceof FormData) {
        var o = {};
        body.forEach(function (v, k) {
          o[k] = v;
        });
        return normalizeItemFromKV(o);
      }
      if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
        var p = {};
        body.forEach(function (v, k) {
          p[k] = v;
        });
        return normalizeItemFromKV(p);
      }
      if (typeof body === "string") {
        var obj = {};
        body.split("&").forEach(function (pair) {
          var kv = pair.split("=");
          if (kv.length === 2)
            obj[decodeURIComponent(kv[0])] = decodeURIComponent(
              kv[1].replace(/\+/g, " ")
            );
        });
        return normalizeItemFromKV(obj);
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function trackATC(itemHint) {
    var now = Date.now();
    if (now - lastATC < 800) return;
    lastATC = now;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var cart = {
          total_price: (data.total_price || 0) / 100,
          $value: (data.total_price || 0) / 100,
          total_discount: data.total_discount || 0,
          original_total_price: (data.original_total_price || 0) / 100,
          cart_items: Array.isArray(data.items) ? data.items : [],
        };
        var item = normalizeItemFromResponse(itemHint) || itemHint || null;
        if (item && !(item.title || item.product_title || item.sku)) {
          var vid = item.id || item.variant_id;
          if (vid && Array.isArray(data.items)) {
            for (var i = 0; i < data.items.length; i++) {
              if (data.items[i].id + "" === vid + "") {
                item = Object.assign({}, data.items[i], {
                  quantity: item.quantity || data.items[i].quantity,
                });
                break;
              }
            }
          }
        }
        if (item) cart = Object.assign(cart, item);
        _learnq.push(["track", "Added to Cart", cart]);
      })
      .catch(function () {
        var cart = { cart_items: [] };
        if (itemHint)
          cart = Object.assign(
            cart,
            normalizeItemFromResponse(itemHint) || itemHint
          );
        _learnq.push(["track", "Added to Cart", cart]);
      });
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var method = (init && init.method) || (input && input.method) || "GET";
      var isATC = /\/cart\/add(\.js)?(\?|$)/i.test(url) && /post/i.test(method || "");
      var bodyItem = parseBodyToItem(init && init.body);
      var p = _fetch.apply(this, arguments);
      if (isATC)
        p.then(function (res) {
          var ok = res && (res.ok || res.status === 302 || res.status === 0);
          if (!ok) return;
          var cloned;
          try {
            cloned = res.clone();
          } catch (e) {
            cloned = null;
          }
          if (cloned) {
            cloned
              .json()
              .then(function (json) {
                var item = normalizeItemFromResponse(json) || bodyItem || json;
                trackATC(item);
              })
              .catch(function () {
                trackATC(bodyItem);
              });
          } else {
            trackATC(bodyItem);
          }
        });
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__klIsATC =
        /\/cart\/add(\.js)?(\?|$)/i.test(url || "") && /post/i.test(method || "");
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      this.__klBodyItem = parseBodyToItem(body);
      if (this.__klIsATC) {
        this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 400) {
            var item;
            try {
              item = JSON.parse(this.responseText);
            } catch (e) {
              item = this.__klBodyItem;
            }
            trackATC(
              normalizeItemFromResponse(item) || item || this.__klBodyItem
            );
          }
        });
      }
      return _send.apply(this, arguments);
    };
  }
})();
